export default __webpack_public_path__ + "static/media/AvenirNextLTPro-Regular.dd7d4308.woff";